import { Dialog } from '@chakra-ui/react';
import SearchContents from '@features/search/SearchContents';
import useCloseModal from 'hooks/useCloseModal';
import { observer } from 'mobx-react-lite';
import { useStores } from 'stores/rootStore';

const SearchModal = () => {
  const { pageStore } = useStores();
  const isOpen = pageStore.isSearchModalOpen();
  const closeModal = useCloseModal();

  return (
    <Dialog.Root
      size="lg"
      lazyMount
      unmountOnExit
      open={isOpen}
      onOpenChange={closeModal}
      placement="center"
      scrollBehavior="inside"
    >
      <Dialog.Backdrop />
      <Dialog.Positioner>
        <Dialog.Content bgColor="surface.background">
          <Dialog.Body p={3}>
            <SearchContents closeModal={closeModal} />
          </Dialog.Body>
        </Dialog.Content>
      </Dialog.Positioner>
    </Dialog.Root>
  );
};

export default observer(SearchModal);
